import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import { body2SemiBold } from "shared";

import { RecoveryCodeLinkProps } from "./types";

const RecoveryCodeLink = ({ onClick }: RecoveryCodeLinkProps) => {
    const { t } = useTranslation();

    return (
        <p
            css={[
                body2SemiBold,
                {
                    display: "flex",
                    alignItems: "center",
                    margin: "8px 0 0 0"
                }
            ]}
        >
            <span>{t("Auth##account verification##no access to otp")}</span>

            <TextLink
                size={TEXT_LINK_SIZES.Normal}
                onClick={() => onClick(true)}
                css={css({
                    marginLeft: "8px"
                })}
            >
                {t("Auth##account verification##use recovery code")}
            </TextLink>
        </p>
    );
};

export default RecoveryCodeLink;
